/* PrettyBundles – fiche produit */
(function () {
  document.querySelectorAll('[data-pb-pdp]').forEach(function (root) {
    var dataEl = root.querySelector('[data-pb-data]');
    if (!dataEl) return;
    var data = JSON.parse(dataEl.textContent);
    var form = root.querySelector('form[action*="/cart/add"]');
    var idInput = root.querySelector('[data-variant-id]');
    var addBtn = root.querySelector('[data-add]');
    var addLabel = root.querySelector('[data-add-label]');
    var stickyBtn = root.querySelector('[data-sticky-add]');
    var errEl = root.querySelector('[data-error]');
    var upCheck = root.querySelector('[data-upsell-check]');
    var upSelect = root.querySelector('[data-upsell-variant]');
    var upBox = root.querySelector('[data-upsell]');

    function money(cents) {
      var v = (cents / 100).toFixed(2);
      var fmt = data.moneyFormat || '{{amount}} €';
      var withComma = v.replace('.', ',');
      var noDec = Math.round(cents / 100).toString();
      return fmt
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withComma)
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, noDec)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDec)
        .replace(/\{\{\s*amount\s*\}\}/, v)
        .replace(/<[^>]*>/g, '');
    }
    function set(sel, text, show) {
      var el = root.querySelector(sel);
      if (!el) return;
      if (text !== undefined) el.textContent = text;
      if (show !== undefined) el.hidden = !show;
    }

    var selected = [];
    root.querySelectorAll('[data-option]').forEach(function (fs) {
      var on = fs.querySelector('[aria-pressed="true"]');
      selected[+fs.dataset.option] = on ? on.dataset.value : null;
    });
    var current = data.variants.find(function (v) { return v.id == idInput.value; }) || data.variants[0];

    function findVariant() {
      return data.variants.find(function (v) {
        return v.options.every(function (o, i) { return selected[i] == null || o === selected[i]; });
      });
    }

    /* Économie par rapport aux bundles à l'unité */
    function words(t) { return (t || '').toLowerCase().replace(/[^a-zàâçéèêëîïôûùüÿ ]/g, ' ').split(/\s+/).filter(function (w) { return w.length > 3; }); }
    function unitTotal(v) {
      if (!data.unitVariants || !data.unitVariants.length) return 0;
      var lengths = (v.title.match(/\d+/g) || []).map(Number).filter(function (n) { return n >= 8 && n <= 40; });
      if (lengths.length < 2) return 0;
      var tw = words(v.title);
      var total = 0;
      for (var i = 0; i < lengths.length; i++) {
        var cands = data.unitVariants.filter(function (u) { return ((u.title.match(/\d+/g) || []).map(Number)).indexOf(lengths[i]) !== -1; });
        if (!cands.length) return 0;
        var best = null, bestScore = 0;
        cands.forEach(function (u) {
          var s = words(u.title).filter(function (w) { return tw.indexOf(w) !== -1; }).length;
          if (s > bestScore) { bestScore = s; best = u; }
        });
        if (!best) {
          if (cands.length > 1) return 0;
          best = cands[0];
        }
        total += best.price;
      }
      return total;
    }

    function upsellPrice() {
      if (!upCheck || !upCheck.checked || !upSelect || !upSelect.value) return 0;
      var o = upSelect.options[upSelect.selectedIndex];
      return o ? +o.dataset.price : 0;
    }

    function render() {
      var v = current;
      var total = v.price + upsellPrice();
      set('[data-price]', money(v.price));
      set('[data-klarna]', 'ou 3 paiements de ' + money(Math.floor(v.price / 3)) + ' sans frais avec Klarna');
      var ut = unitTotal(v);
      var unitEl = root.querySelector('[data-unit]');
      var n = (v.title.match(/\d+/g) || []).filter(function (x) { return +x >= 8 && +x <= 40; }).length;
      if (ut > v.price) {
        unitEl.textContent = money(ut);
        unitEl.hidden = false;
        set('[data-save]', 'Tu économises ' + money(ut - v.price) + ' par rapport à ' + n + ' bundles achetés à l’unité', true);
      } else {
        unitEl.hidden = true;
        set('[data-save]', '', false);
      }
      idInput.value = v.id;
      var can = v.available;
      addBtn.disabled = !can;
      if (stickyBtn) stickyBtn.disabled = !can;
      addLabel.textContent = can ? 'Ajouter au panier · ' + money(total) : 'Épuisé';
      set('[data-sticky-price]', money(total));
      set('[data-sticky-klarna]', 'ou 3x ' + money(Math.floor(total / 3)));

      root.querySelectorAll('[data-option]').forEach(function (fs) {
        var idx = +fs.dataset.option;
        var label = fs.querySelector('[data-option-label]');
        if (label) label.textContent = selected[idx];
        fs.querySelectorAll('.pb-pill').forEach(function (b) {
          b.setAttribute('aria-pressed', b.dataset.value === selected[idx] ? 'true' : 'false');
          var test = selected.slice(); test[idx] = b.dataset.value;
          /* Une valeur existe / est dispo si une variante la porte avec les choix précédents (on ignore les choix suivants) */
          var match = function (x) {
            if (x.options[idx] !== b.dataset.value) return false;
            for (var j = 0; j < idx; j++) { if (selected[j] != null && x.options[j] !== selected[j]) return false; }
            return true;
          };
          var exists = data.variants.some(match);
          var ok = data.variants.some(function (x) { return x.available && match(x); });
          b.classList.toggle('is-unavailable', exists && !ok);
          b.hidden = !exists;
        });
      });
      if (window.history && history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url.toString());
      }
    }

    root.querySelectorAll('[data-option]').forEach(function (fs) {
      fs.addEventListener('click', function (e) {
        var b = e.target.closest('.pb-pill');
        if (!b) return;
        selected[+fs.dataset.option] = b.dataset.value;
        var v = findVariant();
        if (!v) {
          var k = +fs.dataset.option;
          var before = function (x) { for (var j = 0; j < k; j++) { if (selected[j] != null && x.options[j] !== selected[j]) return false; } return x.options[k] === b.dataset.value; };
          v = data.variants.find(function (x) { return before(x) && x.available; })
            || data.variants.find(before)
            || data.variants.find(function (x) { return x.options[k] === b.dataset.value; });
          if (v) selected = v.options.slice();
        }
        if (v) {
          current = v;
          if (v.media) goToMedia(v.media);
        }
        render();
      });
    });

    if (upCheck) {
      upCheck.addEventListener('change', function () {
        upSelect.hidden = !upCheck.checked;
        upBox.classList.toggle('is-on', upCheck.checked);
        render();
      });
      upSelect.addEventListener('change', render);
    }

    /* Galerie */
    var track = root.querySelector('[data-track]');
    var thumbs = root.querySelectorAll('[data-thumb]');
    var dots = root.querySelectorAll('.pb-gallery__dots span');
    function goTo(i) {
      if (!track) return;
      track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
    }
    function goToMedia(id) {
      var slides = track ? Array.prototype.slice.call(track.children) : [];
      var i = slides.findIndex(function (s) { return s.dataset.mediaId == id; });
      if (i >= 0) goTo(i);
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { goTo(+t.dataset.thumb); }); });
    if (track) {
      track.addEventListener('scroll', function () {
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
        dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
      }, { passive: true });
    }

    /* Ajout au panier (avec le produit complémentaire si coché) */
    function submit(e) {
      if (e) e.preventDefault();
      if (!current.available) return;
      var items = [{ id: current.id, quantity: 1 }];
      if (upCheck && upCheck.checked && upSelect.value) items.push({ id: +upSelect.value, quantity: 1 });
      addBtn.disabled = true;
      if (stickyBtn) stickyBtn.disabled = true;
      errEl.hidden = true;
      var drawer = document.querySelector('cart-drawer');
      var payload = { items: items };
      if (drawer && drawer.getSectionsToRender) {
        payload.sections = drawer.getSectionsToRender().map(function (x) { return x.id; });
        payload.sections_url = window.location.pathname;
      }
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.j.description || res.j.message || 'Erreur');
          addBtn.disabled = false;
          if (stickyBtn) stickyBtn.disabled = false;
          if (drawer && drawer.renderContents && res.j.sections) {
            drawer.classList.remove('is-empty');
            res.j.id = current.id;
            drawer.renderContents(res.j);
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') { try { publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: current.id, cartData: res.j }); } catch (e) {} }
          } else {
            window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart';
          }
        })
        .catch(function (err) {
          errEl.textContent = err.message;
          errEl.hidden = false;
          addBtn.disabled = false;
          if (stickyBtn) stickyBtn.disabled = false;
        });
    }
    form.addEventListener('submit', submit);
    if (stickyBtn) stickyBtn.addEventListener('click', submit);

    /* Barre fixe : visible quand le bouton principal n'est plus à l'écran */
    var sticky = root.querySelector('[data-sticky]');
    if (sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var past = !en.isIntersecting && en.boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', past);
        });
      }).observe(addBtn);
    }

    render();
  });
})();
